import type { ReactiveController } from 'lit';

export abstract class TaskReactiveController implements ReactiveController {
  hostConnected() {
    // No-op
  }

  hostDisconnected() {
    // No-op
  }
}
